import { createAction } from 'redux-actions';

import dynaForms from '@elab/core/utils/dynaForms';

import types, { storeName } from './types';

const resetData = createAction(types.RESET_DATA);
const setPreferenceGroups = createAction(types.SET_PREFERENCE_GROUPS);
const setPreferences = createAction(types.SET_PREFERENCES);
const setOtherGroup = createAction(types.SET_OTHER_GROUP);
const setConsentTemplates = createAction(types.SET_CONSENT_TEMPLATES);
const doSubmit = createAction(types.DO_SUBMIT);
const submitCurrentPreference = createAction(types.SUBMIT_CURRENT_PREFERENCE);

export default {
    ...dynaForms.getActions(storeName),
    resetData,
    setPreferenceGroups,
    setPreferences,
    setOtherGroup,
    setConsentTemplates,
    doSubmit,
    submitCurrentPreference,
};
